//  icons
import { FiMail, FiMapPin, FiLinkedin, FiFacebook, FiX } from "react-icons/fi";
import { FaSquareWhatsapp } from "react-icons/fa6";

// services icons
import AIandMachineLearning from "./assets/img/service-selection/AI & Machine learning.png";
import devopsAndAutomation from "./assets/img/service-selection/devops & automation_01.png";
// import devopsAndAutomation from './assets/img/service-selection/devops & automation_02.png';
import digitalMarketing from "./assets/img/service-selection/digital marketing.png";
import mediaAndCreative from "./assets/img/service-selection/media & creative.png";
import softwareDevelopment from "./assets/img/service-selection/software development.png";

// projects images
// software development
import geeksOfGurukul from "./assets/img/projects/geeks of gurukul.png";
import personalPortfolio from "./assets/img/projects/personal portfolio.png";
import needAid from "./assets/img/projects/need aid.png";
import kabbikAudioCloud from "./assets/img/projects/kabbik audio cloud.png";

// AI & ML
import chatBot from "./assets/img/projects/Chat bot.png";
import imageAndVideoRecognation from "./assets/img/projects/Image & Video Recognition for Security.png";
import predictiveAnalytics from "./assets/img/projects/Predictive Analytics for Finance.png";

// DevOps & Automation
import automatedITWorkflow from "./assets/img/projects/Automated IT Workflow System.png";
import CICD from "./assets/img/projects/CI_CD Pipeline for SaaS.png";
import kubernetesBasedMicroservices from "./assets/img/projects/Kubernetes-Based Microservices Architecture.png";

// Digital Marketing
import SEOOptimization from "./assets/img/projects/SEO Optimization for Tech Blog.png";
import contentMarketing from "./assets/img/projects/Content Marketing for SaaS Company.png";
import socialMediaGrowth from "./assets/img/projects/Social Media Growth.png";

// Media & Creative
import customCartoonIllustrations from "./assets/img/projects/Custom Cartoon Illustrations.png";
import corporateVideoEditing from "./assets/img/projects/Corporate Video Editing.png";
import threeDProductDesign from "./assets/img/projects/3D Product Design.png";

// testimonial images

import Aditya from "./assets/img/testimonials/Aditya Verma.png";
import Afnan from "./assets/img/testimonials/Afnan.png";
import Ajay from "./assets/img/testimonials/Ajay.png";
import Chandeep from "./assets/img/testimonials/Chandeep Adhikari.png";
import Jason from "./assets/img/testimonials/Jason.png";
import Jayme from "./assets/img/testimonials/Jayme.png";
import Mark from "./assets/img/testimonials/Mark Thompson.png";
import Nikhil from "./assets/img/testimonials/Nikhil Gupta.png";
import Priya from "./assets/img/testimonials/Priya Jain.png";

// navigation
export const navigation = [
  {
    name: "home",
    href: "/#home",
  },
  {
    name: "about",
    href: "/#about",
  },
  {
    name: "portfolio",
    href: "/#portfolio",
  },
  {
    name: "services",
    href: "/#services",
  },
  {
    name: "testimonials",
    href: "/#testimonials",
  },
  {
    name: "contact",
    href: "/#contact",
  },
];

// social
export const social = [
  {
    iconHeader: <FiLinkedin />,
    iconFooter: <FiLinkedin className="w-[30px] h-[30px]" />,
    href: "https://www.linkedin.com/company/techxneuro/about",
  },
  {
    iconHeader: <FiX className="w-[25px] h-[25px]" />,
    iconFooter: <FiX className="w-[40px] h-[40px]" />,
    href: "https://x.com/tech_x_neuro",
  },
  {
    iconHeader: <FiFacebook />,
    iconFooter: <FiFacebook className="w-[30px] h-[30px]" />,
    href: "https://www.facebook.com/techxneuro",
  },
  {
    iconHeader: <FaSquareWhatsapp />,
    iconFooter: <FaSquareWhatsapp className="w-[30px] h-[30px]" />,
    href: "https://api.whatsapp.com/send?phone=447938955665&text=Hi%20TechXNeuro,%20are%20you%20available%20to%20chat%20?",
  },
];

// companies
export const serviceSelections = [
  {
    img: softwareDevelopment,
    title: "Software Development",
    href: "",
  },

  {
    img: AIandMachineLearning,
    title: "AI & Machine Learning",
    href: "",
  },
  {
    img: devopsAndAutomation,
    title: "Devops & Automation",
    href: "",
  },
  {
    img: digitalMarketing,
    title: "Digital Marketing",
    href: "",
  },
  {
    img: mediaAndCreative,
    title: "Media & Creative",
    href: "",
  },
];

// projects
export const projectsData = [
  // category: "Software Development"
  {
    id: "Software Development_001",
    image: geeksOfGurukul,
    name: "Full-Stack Web: Ed-Tech (LMS)",
    category: "Software Development",
    description:
      "We developed a comprehensive Full-Stack Ed-Tech Solution for Geeks Of Gurukul, a leading online learning platform in India. The project consists of two seamlessly integrated web applications: a Course Marketplace & Advertisement Platform and a Learning Management System (LMS).",
    titleForKeyPoints: "Key Features",
    keyPoints: [
      {
        title: "Course Marketplace & Advertisement Platform",
        content:
          "A dynamic and responsive front-end for showcasing and selling courses, built using React.js and Tailwind CSS for a modern and intuitive UI.",
      },
      {
        title: "Learning Management System (LMS)",
        content:
          "A feature-rich, interactive platform where enrolled students can access their courses, track progress, and engage in real-time discussions.",
      },
      {
        title: "Backend & Database",
        content:
          "The backend is powered by Node.js, Express.js, MongoDB, and Mongoose, ensuring a scalable and efficient system.",
      },
      {
        title: "Real-time Communication",
        content:
          "We integrated Socket.io for real-time interactions, enhancing the learning experience for students.",
      },
      {
        title: "Tech Stack Used",
        content:
          "Frontend: React.js, Tailwind CSS | Backend: Node.js, Express.js, MongoDB, Mongoose | Real-time: Socket.io",
      },
    ],
    conclusion:
      "With this solution, Geeks Of Gurukul has significantly expanded its reach and is now thriving in the Indian Ed-Tech industry, providing an engaging and scalable learning experience to thousands of students.",
  },

  {
    id: "Software Development_002",
    image: needAid,
    name: "Full-Stack: Donation Service",
    category: "Software Development",
    description:
      "We developed a full-stack web platform for Need Aid, a non-profit donation service organization in Bangladesh. The platform facilitates seamless donations, donor engagement, and real-time updates, making the process more efficient and transparent.",
    titleForKeyPoints: "Key Features",
    keyPoints: [
      {
        title: "User-Friendly Donation Platform",
        content:
          "Designed an intuitive and responsive interface for donors and organizations using React.js and Bootstrap.",
      },
      {
        title: "Secure & Scalable Backend",
        content:
          "Built with Node.js and Express.js to handle secure transactions and ensure smooth operations.",
      },
      {
        title: "Real-Time Updates",
        content:
          "Implemented WebSocket for real-time donation tracking and instant notifications to donors and administrators.",
      },
      {
        title: "Impactful and Transparent System",
        content:
          "Provides detailed reports, tracking features, and transparency to ensure donations reach the right people.",
      },
    ],
    conclusion:
      "With this platform, Need Aid has enhanced its donation process, making it easier for people to contribute and ensuring funds are effectively utilized for social impact.",
  },
  {
    id: "Software Development_003",
    image: personalPortfolio,
    name: "Personal Portfolio website",
    category: "Software Development",
    description:
      "We designed and developed a visually stunning and modern 3D personal portfolio website for our special client, Khalid Mim Muzahid. This interactive website showcases his skills, projects, and personal brand in a highly engaging manner.",
    titleForKeyPoints: "Key Features",
    keyPoints: [
      {
        title: "Eye-Catching & Modern 3D Design",
        content:
          "The website features an immersive 3D experience, making it visually unique and engaging.",
      },
      {
        title: "Built with Cutting-Edge Technologies",
        content:
          "Developed using React.js, Tailwind CSS, and Three.js to create a seamless and modern user experience.",
      },
      {
        title: "Interactive User Experience",
        content:
          "The website includes smooth animations, interactive elements, and real-time responsiveness to enhance user engagement.",
      },
      {
        title: "Optimized Performance",
        content:
          "Ensured fast loading times and smooth interactions while maintaining high-quality 3D rendering.",
      },
    ],
    conclusion:
      "This project successfully delivered a highly interactive and modern portfolio website that effectively represents Khalid Mim Muzahid’s personal brand, setting a new standard for online portfolios.",
  },
  {
    id: "Software Development_004",
    image: kabbikAudioCloud,
    name: "Mobile App : Audiobook App",
    category: "Software Development",
    description:
      "Kabbik is an innovative audiobook app available on the Google Play Store. Designed for a seamless listening experience, the app provides users with a vast collection of audiobooks while ensuring high-performance data storage and accessibility.",
    titleForKeyPoints: "Key Features",
    keyPoints: [
      {
        title: "NAS Server for Data Storage",
        content:
          "Implemented a NAS (Network-Attached Storage) server to efficiently store and manage high-quality audio files.",
      },
      {
        title: "Audiobook Streaming & Download",
        content:
          "Users can stream audiobooks in real-time or download them for offline listening, ensuring a smooth and uninterrupted experience.",
      },
      {
        title: "Built with React Native & FastAPI",
        content:
          "Developed using React Native for cross-platform compatibility and FastAPI for a high-speed and scalable backend.",
      },
      {
        title: "Available on Google Play Store",
        content:
          "Kabbik is live on the Play Store, allowing users to explore a diverse collection of audiobooks anytime, anywhere.",
      },
    ],
    conclusion:
      "Kabbik delivers a modern and efficient audiobook experience, leveraging advanced storage solutions and cutting-edge technologies to provide seamless audio streaming and offline listening for users.",
  },
  // category: "AI & Machine Learning"
  {
    id: "AI_ML_001",
    image: chatBot,
    name: "AI-Powered Chatbot for E-Commerce",
    category: "AI & Machine Learning",
    description:
      "Developed an AI chatbot to automate customer support, handle inquiries, and provide product recommendations using NLP.",
    titleForKeyPoints: "Key Features",
    keyPoints: [
      {
        title: "NLP Integration",
        content:
          "We implemented Natural Language Processing (NLP) to make the chatbot capable of understanding and processing human language. This allows the chatbot to provide more intuitive and contextually aware responses to customer queries, offering a seamless conversational experience.",
      },
      {
        title: "Multi-Platform Support",
        content:
          "The chatbot was designed to integrate with various platforms, including web, mobile, and social media platforms like WhatsApp. This broad compatibility ensures customers can interact with the chatbot wherever they are, making it more accessible and efficient.",
      },
      {
        title: "Real-Time Learning",
        content:
          "The chatbot continuously improves itself through machine learning algorithms. It learns from user interactions, adapting and evolving over time to provide better responses and support, ensuring an ever-improving experience for the users.",
      },
    ],
    conclusion:
      "Reduced support costs and improved user engagement, enhancing overall customer satisfaction.",
  },
  {
    id: "AI_ML_002",
    image: imageAndVideoRecognation,
    name: "Image & Video Recognition for Security",
    category: "AI & Machine Learning",
    description:
      "Developed an AI-based computer vision system for facial and object recognition in surveillance footage.",
    titleForKeyPoints: "Key Features",
    keyPoints: [
      {
        title: "Real-Time Detection",
        content:
          "The system is capable of analyzing video streams in real time, instantly identifying faces, objects, and even suspicious behavior. This allows security teams to monitor and respond to security threats as they happen, minimizing potential risks.",
      },
      {
        title: "Deep Learning Models",
        content:
          "We leveraged deep learning models trained on large datasets, enabling the system to recognize a wide variety of faces, objects, and behaviors with high accuracy. These models were continuously improved to stay ahead of new challenges.",
      },
      {
        title: "Cloud & Edge Processing",
        content:
          "The system supports both cloud and edge processing. This allows for real-time analysis at the source, reducing latency and ensuring faster response times, while also offering cloud storage for large datasets and detailed analysis.",
      },
    ],
    conclusion:
      "Enhanced security monitoring for enterprises, improving safety and surveillance operations.",
  },
  {
    id: "AI_ML_003",
    image: predictiveAnalytics,
    name: "Predictive Analytics for Finance",
    category: "AI & Machine Learning",
    description:
      "Built a predictive analytics model to forecast stock prices and financial trends using ML algorithms.",
    titleForKeyPoints: "Key Features",
    keyPoints: [
      {
        title: "Time-Series Analysis",
        content:
          "We used time-series analysis to study historical financial data and predict future stock prices. By analyzing patterns, seasonal trends, and market cycles, the system makes accurate forecasts for investors and traders to base their decisions on.",
      },
      {
        title: "AI-Powered Insights",
        content:
          "Our machine learning algorithms provide AI-powered insights, including predictive models and risk assessments, helping investors identify high-potential opportunities and mitigate risks in the volatile financial market.",
      },
      {
        title: "Automated Alerts",
        content:
          "The system is equipped with automated alerts that notify users about significant market changes. This feature helps traders act swiftly in response to shifts in stock prices, ensuring they never miss a profitable opportunity.",
      },
    ],
    conclusion:
      "Enabled data-driven financial decision-making, helping users optimize investments and reduce risks.",
  },

  //category: "DevOps & Automation Projects"
  {
    id: "DevOps_001",
    image: CICD,
    name: "CI/CD Pipeline for SaaS",
    category: "DevOps & Automation",
    description:
      "Implemented a CI/CD pipeline to automate deployment and testing for a SaaS platform.",
    titleForKeyPoints: "Key Features",
    keyPoints: [
      {
        title: "Automated Testing",
        content:
          "We implemented automated testing to run unit tests and integration tests with every code commit. This ensures that only thoroughly tested code is deployed to production, minimizing the risk of bugs and ensuring high-quality software releases.",
      },
      {
        title: "Infrastructure as Code",
        content:
          "Using Terraform, we set up and managed the cloud infrastructure for the application in a repeatable, automated manner. This approach allows for easy scaling, provisioning, and configuration management, resulting in a more robust and flexible infrastructure.",
      },
      {
        title: "Zero-Downtime Deployment",
        content:
          "Our solution ensures zero downtime during deployments, allowing for continuous operation of the SaaS platform. With blue-green deployment strategies and load balancers, we ensure that updates do not interrupt the service for end users.",
      },
    ],
    conclusion:
      "Reduced deployment time and increased stability, ensuring faster feature rollouts and higher uptime.",
  },
  {
    id: "DevOps_002",
    image: kubernetesBasedMicroservices,
    name: "Kubernetes-Based Microservices Architecture",
    category: "DevOps & Automation",
    description:
      "Designed a microservices architecture with Kubernetes for an enterprise application.",
    titleForKeyPoints: "Key Features",
    keyPoints: [
      {
        title: "Scalable Deployment",
        content:
          "Using Kubernetes, we orchestrated containerized applications to scale dynamically based on demand. This ensures that resources are allocated efficiently, even during high traffic periods, allowing the platform to handle large volumes of users seamlessly.",
      },
      {
        title: "Service Mesh Integration",
        content:
          "We integrated a service mesh to manage communication between microservices. This enhances security, monitoring, and traffic management, ensuring the system is robust, fault-tolerant, and easy to manage.",
      },
      {
        title: "Automated Load Balancing",
        content:
          "The system intelligently distributes traffic among microservices using automated load balancing techniques, ensuring no single service is overwhelmed and maintaining high availability even during peak usage.",
      },
    ],
    conclusion:
      "Improved performance, scalability, and fault tolerance, allowing the company to handle growing customer demand with ease.",
  },
  {
    id: "DevOps_003",
    image: automatedITWorkflow,
    name: "Automated IT Workflow System",
    category: "DevOps & Automation",
    description:
      "Developed a workflow automation system to streamline IT operations for a tech enterprise.",
    titleForKeyPoints: "Key Features",
    keyPoints: [
      {
        title: "Process Automation",
        content:
          "We automated repetitive IT tasks like server provisioning, incident management, and patch deployment, saving time and reducing human error. This allowed the IT team to focus on more strategic initiatives, improving overall efficiency.",
      },
      {
        title: "Integrated with ITSM",
        content:
          "The system seamlessly integrated with popular IT Service Management (ITSM) tools like ServiceNow and Jira, ensuring smooth ticket management, issue tracking, and real-time collaboration between IT teams and stakeholders.",
      },
      {
        title: "AI-Powered Monitoring",
        content:
          "The system uses AI-driven monitoring to proactively detect system anomalies and resolve issues before they impact business operations. This predictive approach to IT management significantly reduces downtime and improves service availability.",
      },
    ],
    conclusion:
      "Increased operational efficiency and reduced IT overhead, enabling IT teams to deliver faster and more reliable services.",
  },
  //category: Digital Marketing Projects
  {
    id: "DigitalMarketing_001",
    image: socialMediaGrowth,
    name: "Social Media Growth for Fashion Brand",
    category: "Digital Marketing",
    description:
      "Executed a social media strategy that grew brand engagement and boosted sales for a fashion retailer through a combination of targeted paid ads, influencer collaborations, and engaging content creation.",
    titleForKeyPoints: "Key Features",
    keyPoints: [
      {
        title: "Paid Ads & Targeting",
        content:
          "Launched highly optimized advertising campaigns on Facebook and Instagram, ensuring the brand reached its ideal audience. Utilized retargeting strategies and A/B testing to improve engagement and maximize ROI.",
      },
      {
        title: "Content Strategy",
        content:
          "Designed a mix of visually appealing reels, carousels, and user-generated content that resonated with the audience. Focused on storytelling, product demonstrations, and interactive posts to drive engagement.",
      },
      {
        title: "Analytics & A/B Testing",
        content:
          "Analyzed engagement metrics, click-through rates, and customer behavior to refine marketing strategies. Used A/B testing on creatives and ad copies to improve conversion rates and optimize ad spend.",
      },
    ],
    conclusion:
      "This campaign led to a 40% increase in conversions within six months, strengthening brand visibility and boosting sales revenue.",
  },
  {
    id: "DigitalMarketing_002",
    image: SEOOptimization,
    name: "SEO Optimization for Tech Blog",
    category: "Digital Marketing",
    description:
      "Implemented a structured SEO strategy for a leading technology blog, improving search rankings, increasing organic traffic, and optimizing content for better visibility across search engines.",
    titleForKeyPoints: "Key Features",
    keyPoints: [
      {
        title: "Comprehensive Keyword Research",
        content:
          "Conducted in-depth research to identify high-volume, low-competition keywords relevant to the tech industry. Implemented long-tail keywords to capture niche search traffic.",
      },
      {
        title: "On-Page SEO & Structured Content",
        content:
          "Optimized blog posts with compelling meta descriptions, structured headings, internal linking, and keyword placement. Ensured mobile-friendly and fast-loading pages to enhance user experience.",
      },
      {
        title: "Backlink Strategy & Domain Authority Growth",
        content:
          "Developed an authoritative backlink strategy by guest posting on high-ranking tech websites, collaborating with industry influencers, and leveraging social media shares to improve domain authority.",
      },
    ],
    conclusion:
      "The SEO efforts doubled the blog’s organic traffic within four months, significantly improving search engine rankings and audience reach.",
  },
  {
    id: "DigitalMarketing_003",
    image: contentMarketing,
    name: "Content Marketing for SaaS Company",
    category: "Digital Marketing",
    description:
      "Designed a content marketing strategy that enhanced brand authority and lead generation for a SaaS company, driving organic traffic and improving customer acquisition rates.",
    titleForKeyPoints: "Key Features",
    keyPoints: [
      {
        title: "High-Value Blog Content Strategy",
        content:
          "Created educational and problem-solving blog articles that addressed industry pain points, helping potential customers understand the SaaS product’s value proposition.",
      },
      {
        title: "Video Content & Explainer Series",
        content:
          "Developed engaging explainer videos demonstrating key features of the SaaS product, simplifying complex concepts for prospective clients and improving retention rates.",
      },
      {
        title: "Lead Magnets & Whitepapers",
        content:
          "Designed downloadable whitepapers, case studies, and e-books that provided in-depth insights into industry trends, driving inbound leads through gated content.",
      },
    ],
    conclusion:
      "Generated high-quality leads, increased conversion rates, and established the SaaS company as an industry thought leader.",
  },

  //category: Media & Creative Projects
  {
    id: "MediaCreative_001",
    image: customCartoonIllustrations,
    name: "Custom Cartoon Illustrations for Children's Book",
    category: "Media & Creative",
    description:
      "Created vibrant and engaging cartoon illustrations for a children's book, bringing the story to life with unique character designs and immersive scenes.",
    titleForKeyPoints: "Key Features",
    keyPoints: [
      {
        title: "Vibrant & Eye-Catching Colors",
        content:
          "Utilized a bright and cheerful color palette to attract young readers. Applied contrast and shading techniques to enhance depth and visual appeal.",
      },
      {
        title: "Unique Character Design & Story Integration",
        content:
          "Designed expressive characters with distinct personalities that reflected the story’s theme. Ensured seamless integration of illustrations with the book’s narrative for an immersive experience.",
      },
      {
        title: "High-Resolution Artwork for Print & Digital",
        content:
          "Delivered print-ready high-resolution illustrations while optimizing versions for digital platforms such as e-books and interactive storytelling apps.",
      },
    ],
    conclusion:
      "The visually rich illustrations significantly enhanced the storytelling experience, making the book more engaging and marketable.",
  },
  {
    id: "MediaCreative_002",
    image: corporateVideoEditing,
    name: "Corporate Video Editing for Tech Company",
    category: "Media & Creative",
    description:
      "Produced and edited a series of corporate videos for a tech company, including product demos, promotional content, and internal training materials.",
    titleForKeyPoints: "Key Features",
    keyPoints: [
      {
        title: "Professional Motion Graphics & Visual Effects",
        content:
          "Incorporated dynamic motion graphics, animations, and transitions to create polished, engaging video content that captured audience attention.",
      },
      {
        title: "Brand Identity & Consistency",
        content:
          "Ensured that all video elements, including colors, fonts, and transitions, aligned with the company's branding to create a cohesive visual identity.",
      },
      {
        title: "Multi-Platform Optimization",
        content:
          "Edited videos for multiple platforms such as YouTube, LinkedIn, and social media, ensuring optimal resolution, aspect ratios, and engagement-focused edits.",
      },
    ],
    conclusion:
      "The corporate videos enhanced brand presence, improved user engagement, and effectively showcased the company’s technology solutions.",
  },
  {
    id: "MediaCreative_003",
    image: threeDProductDesign,
    name: "3D Product Design for Marketing Campaign",
    category: "Media & Creative",
    description:
      "Designed realistic 3D product renders for an innovative digital marketing campaign, allowing consumers to visualize products with high accuracy before purchase.",
    titleForKeyPoints: "Key Features",
    keyPoints: [
      {
        title: "Photorealistic Rendering & Texture Detailing",
        content:
          "Applied advanced 3D rendering techniques, including realistic lighting, reflections, and high-resolution textures, to create life-like product visuals.",
      },
      {
        title: "Multiple Camera Angles & Interactive Views",
        content:
          "Generated various perspectives and 360-degree views to provide a detailed look at product features, improving user interaction and confidence in purchasing decisions.",
      },
      {
        title: "Integration with Augmented Reality (AR) & Virtual Reality (VR)",
        content:
          "Optimized 3D models for AR/VR applications, enabling users to experience products in an immersive environment before making a purchase decision.",
      },
    ],
    conclusion:
      "The 3D product visuals significantly boosted customer engagement, increasing conversions and enhancing the brand’s digital marketing impact.",
  },
];

// projects
export const projectsNav = [
  {
    name: "all",
  },
  {
    name: "Software Development",
  },
  {
    name: "AI & Machine Learning",
  },
  {
    name: "Devops & Automation",
  },
  {
    name: "Digital Marketing",
  },
  {
    name: "Media & Creative",
  },
];

// services

export const services = [
  {
    icon: softwareDevelopment,
    title: "Software Development",
    services: [
      "Mobile App Development",
      "iOS & Android Development",
      "Cross-Platform App Development",
      "Website Development",
      "Frontend & Backend Development",
      // "Full-Stack Development",
      "API Development",
      "Third-Party API Integration",
      "Custom API Solutions",
      "SaaS Development",
      "Enterprise Software Solutions",
    ],
  },

  {
    icon: AIandMachineLearning,
    title: "AI & Machine Learning",
    services: [
      "AI Solutions",
      "Chatbot & Virtual Assistants",
      "AI-Powered Automation",
      "Machine Learning Model Development",
      "Predictive Analytics",
      "Natural Language Processing (NLP)",
      "Computer Vision",
      "Data Science & AI Consulting",
    ],
  },

  {
    icon: devopsAndAutomation,
    title: "DevOps & Automation",
    services: [
      "DevOps Consulting",
      "CI/CD Implementation",
      "Cloud Infrastructure Management",
      "Containerization (Docker, Kubernetes)",
      "Serverless Computing",
      "Infrastructure as Code (IaC)",
      "Monitoring & Logging Solutions",
      "Process Automation",
      "Security & Compliance Automation",
    ],
  },

  {
    icon: digitalMarketing,
    title: "Digital Marketing",
    services: [
      "Email Marketing",
      "Marketing Automation",
      "Social Media Management",
      "Paid Advertising (PPC, Google Ads, Meta Ads)",
      "SEO Services",
      "Technical SEO",
      "On-Page & Off-Page SEO",
      "Local SEO Optimization",
      "Content Marketing",
      // "Copywriting & Blogging",
      "Video & Podcast Marketing",
      // "Influencer Marketing",
      // "Conversion Rate Optimization (CRO)",
    ],
  },

  {
    icon: mediaAndCreative,
    title: "Media & Creative",
    services: [
      "Custom Illustrations",
      "Concept Art & Character Design",
      "NFT & Digital Art",
      "Vector & 3D Illustrations",
      "Video Editing",
      "Motion Graphics & Animation",
      "Corporate & Promotional Videos",
      "Graphic Design",
      "Logo & Branding",
      "UI/UX Design",
      // "Print & Marketing Materials",
    ],
  },
];

// testimonials
export const testimonials = [
  {
    industry: "AI",
    authorImg: Afnan,
    authorText:
      "TechXNeuro delivered a seamless, high-quality solution tailored to our needs. Their expertise in real-time systems and big data, combined with a strategic and cost-effective approach, made a significant impact. Communication was effortless, ensuring smooth execution and a successful outcome. We highly recommend TechXNeuro as a reliable, forward-thinking technology partner.",
    authorName: "Afnan Islam, PhD",
    authorPosition: "Vice President of Business Development, BotFactory, Inc.",
  },
  {
    industry: "Software Development",
    authorImg: Jayme,
    authorText:
      "TechXNeuro delivered an outstanding solution tailored to our needs. Their expertise in Node.js, React.js, and complex software development was evident throughout the project. Beyond their technical skills, their collaborative approach and clear communication ensured a smooth and successful execution. We highly recommend TechXNeuro as a trusted technology partner committed to excellence and innovation.",
    authorName: "Jayme Brown",
    authorPosition: "Co-Founder, ANTT Robotics Ltd",
  },
  {
    industry: "Software Development",
    authorImg: Ajay,
    authorText:
      "TechXNeuro's full‑stack development expertise delivered a robust and scalable solution for our educational platform. Their integration of innovative design with seamless functionality exceeded our expectations, setting a new standard in digital learning",
    authorName: "Ajay Katana",
    authorPosition: "Co-Founder & CTO, Geeks of Gurukul ",
  },

  {
    industry: "DevOps & Automation",
    authorImg: Chandeep,
    authorText:
      "The CI/CD pipeline implemented by TechXNeuro streamlined our deployment process and significantly reduced downtime. Their expertise in automation has accelerated our release cycles beyond expectations.",
    authorName: "Chandeep Adhikari",
    authorPosition: "Solutions Architect, Alex Solutions",
  },

  {
    industry: "Media & Creative",
    authorImg: Jason,
    authorText:
      "The corporate video editing services provided by TechXNeuro brought our brand story to life. Their innovative use of motion graphics and visual effects created compelling content that truly resonates with our audience.",
    authorName: "Jason Brown",
    authorPosition: "Corporate Communications Manager, Tech Solutions Inc",
  },

  {
    industry: "DevOps & Automation",
    authorImg: Mark,
    authorText:
      "Transitioning to a microservices architecture with TechXNeuro's Kubernetes‑based solution was a game‑changer. Their expertise ensured scalability and resilience, significantly boosting our system's performance during peak loads.",
    authorName: "Mark Thompson",
    authorPosition: "DevOps Lead,, CloudScale Solutions",
  },
  {
    industry: "Software Development",
    authorImg: Priya,
    authorText:
      "Working with TechXNeuro was a transformative experience. Their attention to detail on our API integration project and robust full‑stack solutions redefined our digital platform.",
    authorName: "Priya Jain",
    authorPosition: "Lead Developer, EduStream Inc",
  },

  {
    industry: "Software Development",
    authorImg: Aditya,
    authorText:
      "TechXNeuro’s expertise in SaaS development streamlined our operations and delivered a scalable, user-friendly platform. Their collaborative approach made all the difference.",
    authorName: "Aditya Verma",
    authorPosition: "CTO, CloudHub Solutions",
  },

  {
    industry: "Software Development",
    authorImg: Nikhil,
    authorText:
      "The custom illustrations and corporate video editing by TechXNeuro elevated our brand identity. Their creative approach resonated with our audience and gave our materials a fresh, modern appeal.",
    authorName: "Nikhil Gupta",
    authorPosition: "Brand Manager, Visionary Ventures",
  },
];

// contact
export const contact = [
  {
    icon: <FiMail />,
    title: "Have a question?",
    subtitle: "We are here to help you.",
    description: "Email us at contact@techxneuro.com",
    phone: "+44-7938955665",
    phone2: "+880-1716204599",
  },
  {
    icon: <FiMapPin />,
    title: "Current Location",
    locations: [
      "UK: Chelsea, London, SW3 4NB, UK",
      "BD: Banani, Dhaka 1213, Bangladesh",
    ],
    description: "Serving clients worldwide",
  },
];
